import React, { useState, useEffect, Fragment } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import { getAgent, updateUserInfo, updateUserPassword } from '../../services/http';
import Select, { StylesConfig } from 'react-select';
import { FiEye } from "react-icons/fi";
import { AiFillEyeInvisible } from "react-icons/ai";
import Loader from '../../components/Loader/Loader';
import male_avatar from '../../assets/images/male_avatar.svg';
import female_avatar from '../../assets/images/female_avatar.svg';
import './UserDetails.css';
import { ImProfile } from 'react-icons/im';
import { RiLockPasswordLine } from 'react-icons/ri';
import { toast } from 'react-toastify';
import ProcessSpinner from '../../components/ProcessSpinner/ProcessSpinner';
import { handleMenuSelection } from '../../utils/utils';



const UserDetails = (props) => {

    // const id_user = useParams()
    const navigate = useNavigate()
    const [agent, setAgent] = useState({ nom: "", poste: "", prenom: "", sexe: { label: "", value: "" }, telephone: "", email: "", categorieInstitution: { label: "", value: "" }, institution: { label: "", value: "" }, password: "", type: { label: "", value: "" }, roles: [], isBCC: { label: "", value: "" } });

    const [displayLoader, setDisplayLoader] = useState(true);
    const [processOngoingInfo, setProcessOngoingInfo] = useState(false)
    const [processOngoingPassword, setProcessOngoingPassword] = useState(false)

    const [password, setPassword] = useState({ old: "", new: "", confirmed: "" })

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);
    const [roles, setRoles] = useState([{ value: "", label: "" }]);

    const [showErrorNom, setShowErrorNom] = useState(false)
    const [showErrorPrenom, setShowErrorPrenom] = useState(false)
    const [showErrorEmail, setShowErrorEmail] = useState(false)
    const [showErrorTelephone, setShowErrorTelephone] = useState(false)
    const [showErrorSexe, setShowErrorSexe] = useState(false)
    const [showErrorPassword, setShowErrorPassword] = useState(false)
    const [showErrorOldPassword, setShowErrorOldPassword] = useState(false)
    const [showErrorNewPassword, setShowErrorNewPassword] = useState(false)
    const [showErrorConfirmedPassword, setShowErrorConfirmedPassword] = useState(false)



    const [nomErrorMessage, setNomErrorMessage] = useState("")
    const [prenomErrorMessage, setPrenomErrorMessage] = useState("")
    const [emailErrorMessage, setEmailErrorMessage] = useState("")
    const [telephoneErrorMessage, setTelephoneErrorMessage] = useState("")
    const [sexeErrorMessage, setSexeErrorMessage] = useState("")
    const [passwordErrorMessage, setPasswordErrorMessage] = useState("")
    const [oldPasswordErrorMessage, setOldPasswordErrorMessage] = useState("")
    const [newPasswordErrorMessage, setNewPasswordErrorMessage] = useState("")
    const [confirmedPasswordErrorMessage, setConfirmedPasswordErrorMessage] = useState("")



    const [activeMenu, setActiveMenu] = useState("perso_info")

    const sexAgent = [
        { value: "M", label: "Masculin" },
        { value: "F", label: "Féminin" }
    ]


    const typeAgent = [
        { label: "directeur", value: "directeur" },
        { label: "agent", value: "agent" }
    ]

    // To populate the breadcrumb and update the sidebar menu
    useEffect(() => {
        let type;
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Profil", firstLevelLink: "", secondLevelText: "Utilisateur", secondLevelLink: "", thirdLevelText: agent.prenom + " " + agent.nom, thirdLevelLink: ``
            }
        });
    handleMenuSelection("user", dispatch, states);


    }, [])

    useEffect(() => {
        if (agent.nom != "") {
            setShowErrorNom(false)
        }
        if (agent.prenom != "") {
            setShowErrorPrenom(false)
        }

        if (agent.email != "") {
            setShowErrorEmail(false)
        }
        if (agent.telephone != "") {
            setShowErrorTelephone(false)
        }
        if (agent.sexe.value != "") {
            setShowErrorSexe(false)
        }
    }, [agent])

    useEffect(() => {
        if (password.old != "") {
            setShowErrorOldPassword(false)
        }
        if (password.new != "") {
            setShowErrorNewPassword(false)
        }

        if (password.confirmed != "") {
            setShowErrorConfirmedPassword(false)
        }
    }, [password])

    const handleDisplayOldPassword = () => {
        if (showOldPassword === true) {
            setShowOldPassword(false)
        } else {
            setShowOldPassword(true)
        }
    }

    const handleDisplayNewPassword = () => {
        if (showNewPassword === true) {
            setShowNewPassword(false)
        } else {
            setShowNewPassword(true)
        }
    }

    const handleDisplayConfirmedPassword = () => {
        if (showConfirmedPassword === true) {
            setShowConfirmedPassword(false)
        } else {
            setShowConfirmedPassword(true)
        }
    }

    const handleChangePassword = (type, e) => {
        let value = e.target.value;
        if (type === "old") {
            setPassword({ ...password, old: value })
        }
        if (type === "new") {
            setPassword({ ...password, new: value })
        }
        if (type === "confirmed") {
            setPassword({ ...password, confirmed: value })
        }
    }

    const handleChangeEntry = (key, e) => {
        var value = e.currentTarget.value;
        if (key == "nom") {
            setAgent({ ...agent, nom: value });
        }
        if (key == "prenom") {
            setAgent({ ...agent, prenom: value });
        }
        if (key == "telephone") {
            setAgent({ ...agent, telephone: value });
        }
        if (key == "email") {
            setAgent({ ...agent, email: value });
        }
    }

    const selection = (e, key) => {
        if (key == "sexe") {
            setAgent({ ...agent, sexe: { value: e.value, label: e.label } })

        }

    }

    const loadUserData = async () => {
        console.log("states.userInfo ", states.userInfo.id)
        const agent = { id_agent: states.userInfo.id }
        const resp = await getAgent(agent, states.userToken.access_token)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data ", resp.data)
            let data_received = resp.data;
            console.log("Data of Agent  ", data_received)
            const newData = resp.data?.agent?.roles?.map(value => ({
                value: value.id,
                label: value.name,

            }))
            var agent_info = data_received.agent;
            var sexAgentLabel = data_received.agent.sexe === "M" ? "Masculin" : "Féminin"

            // setRoles(newData)
            setAgent({
                ...agent, nom: agent_info.nom,
                poste: agent_info.poste,
                prenom: agent_info.prenom,
                sexe: { value: agent_info.sexe, label: sexAgentLabel },
                telephone: data_received.agent.telephone,
                email: data_received.agent.email,
            })
            setDisplayLoader(false)
        }

    }

    useEffect(() => {
        
    console.log("agent UserInfo", agent)
    }, [agent]);

    // useEffect(() => {
    //     if(window.location.pathname !== "/user-details") {
    //         navigate("/user-details")
    //      }
    //   }, [])

    const dispatch = useDispatch();

    const states = useSelector((state) => state, shallowEqual);

    const handleBack = () => {
        navigate("/")
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '35px',
            height: '35px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '35px',
            padding: '0 6px',
            marginTop: '-5px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
            //   height: '30px'
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '35px',
        }),
    };


    useEffect(() => {
        loadUserData();
        console.log("userInfo ", states.userInfo)
    }, [states.userInfo.id])

    // Update User Personal Info 
    const handleUpdateUserPersoInfo = async () => {
        setProcessOngoingInfo(true)
        // console.log("Here is agent to add", agent)
        const reqdata = await updateUserInfo(states.userToken.access_token, agent);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoingInfo(false)
                // console.log(reqdata.response?.data.error["nom"][0].length)
                if (reqdata.response?.data.error.nom) {
                    var errorMsg1 = reqdata.response?.data.error.nom[0];
                    setShowErrorNom(true)
                    setNomErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.prenom) {
                    var errorMsg1 = reqdata.response?.data.error.prenom[0];
                    setShowErrorPrenom(true)
                    setPrenomErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.email) {
                    var errorMsg2 = reqdata.response?.data.error.email[0];
                    setShowErrorEmail(true)
                    setEmailErrorMessage(errorMsg2)
                }
                if (reqdata.response?.data.error.telephone) {
                    var errorMsg3 = reqdata.response?.data.error.telephone[0];
                    setShowErrorTelephone(true)
                    setTelephoneErrorMessage(errorMsg3)
                }
                if (reqdata.response?.data.error.sexe) {
                    var errorMsg3 = reqdata.response?.data.error.sexe[0];
                    setShowErrorSexe(true)
                    setSexeErrorMessage(errorMsg3)
                }

            } else {
                setProcessOngoingInfo(false)
                // console.log(reqdata.response)
                toast.error(reqdata.response?.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoingInfo(false)
            // console.log("Here we are")
            toast.success(`Vos informations personnelles ont été mises à jour avec succès.`, {
                position: toast.POSITION.TOP_RIGHT
            });

        }
    }



    // Update User Password
    const handleUpdateUserPassword = async () => {
        setProcessOngoingPassword(true)
        // console.log("Here is agent to add", agent)
        const reqdata = await updateUserPassword(states.userToken.access_token, password);
        if (reqdata.response && reqdata.response.status !== 200) {
            console.log("Error", reqdata.response)
            setProcessOngoingPassword(false)
            if (reqdata.response.status === 422) {
                // console.log(reqdata.response?.data.error["oldpassword"][0].length)
                if (reqdata.response?.data.error.oldpassword) {
                    var errorMsg1 = reqdata.response?.data.error.oldpassword[0];
                    setShowErrorOldPassword(true)
                    setOldPasswordErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.newpassword) {
                    var errorMsg1 = reqdata.response?.data.error.newpassword[0];
                    setShowErrorNewPassword(true)
                    setNewPasswordErrorMessage(errorMsg1)
                }
                if (reqdata.response?.data.error.confirmpassword) {
                    var errorMsg2 = reqdata.response?.data.error.confirmpassword[0];
                    setShowErrorConfirmedPassword(true)
                    setConfirmedPasswordErrorMessage(errorMsg2)
                }

                // } else {
                //     setProcessOngoing(false)
                //     console.log(reqdata.response)
                toast.error(reqdata.response?.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
                }
            } else {
                setProcessOngoingPassword(false)
                toast.success(`Mot de passe modifié avec succès.`, {
                    position: toast.POSITION.TOP_RIGHT
                });

            }
        }

    

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    {displayLoader == false ?
                        <div className="layout-px-spacing">

                            <div className="row layout-top-spacing">
                                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                                </div>
                            </div>
                            <div className="w-90">
                                <h4 className="modal-title py-1 text-left " id="exampleModalLabel">{"Profil Agent"}</h4>
                            </div>
                            <div className='d-flex justify-content-around row flex-wrap'>
                                <div className="widget widget-content widget-content-area mt-3 pt-3 col-sm-4 col-xs-12">
                                    <div className="w-90 mx-auto">
                                    </div>
                                    <div className="w-90 mx-auto">

                                        <img className='user-avatar' src={agent.sexe?.value == "F" ? female_avatar : male_avatar} alt="avatar" />
                                        <h3 className='mb-3'><em>{agent?.prenom}</em> {" "} {agent?.nom}</h3>
                                        <p className='d-flex justify-content-between'><em className='t-left'>Mail: </em><b className='t-right text-dark'>{agent.email}</b></p>
                                        <p className='d-flex justify-content-between'><em className='t-left'>Téléphone: </em><b className='t-right text-dark'>{agent.telephone}</b></p>
                                        <p className='d-flex justify-content-between mb-5'><em className='t-left d-flex-flex-nowrap'>Institution: </em><b className='t-right text-dark'>{states.userInfo.institution.libelle}</b></p>
                                       
                                        <div onClick={() => setActiveMenu("perso_info")}
                                            className={activeMenu === "perso_info" ? 'd-flex justify-content-between profil-menu mx-auto widget widget-content widget-content-area mb-4 profil-menu-active' : 'd-flex justify-content-between profil-menu mx-auto widget widget-content widget-content-area mb-4'}
                                        >
                                            <ImProfile className={activeMenu === "perso_info" ? 'profil-menu-icon my-auto ml-2 profil-menu-icon-active' : 'profil-menu-icon my-auto ml-2'} /> <h6 className={activeMenu === "perso_info" ? 'mr-3 profil-menu-text my-auto profil-menu-text-active' : 'mr-3 profil-menu-text my-auto'}>Informations personnelles</h6>
                                        </div>
                                        {/* {JSON.stringify(activeMenu)} */}
                                        <div onClick={() => setActiveMenu("change_password")}
                                            className={activeMenu === "change_password" ? 'd-flex justify-content-between profil-menu mx-auto widget widget-content widget-content-area mb-3 profil-menu-active' : 'd-flex justify-content-between profil-menu mx-auto widget widget-content widget-content-area mb-3'}
                                        >
                                            <RiLockPasswordLine className={activeMenu === "change_password" ? 'profil-menu-icon my-auto ml-2 profil-menu-icon-active' : 'profil-menu-icon my-auto ml-2'} /> <h6 className={activeMenu === "change_password" ? 'mr-3 profil-menu-text my-auto profil-menu-text-active' : 'mr-3 profil-menu-text my-auto'}>Changer le mot de passe</h6>
                                        </div>

                                    </div>
                                    <div className="row my-3"></div>

                                </div>

                                <div className="widget widget-content widget-content-area mt-3 pt-3 col-sm-7 col-xs-12">
                                    <div className="w-90 mx-auto">
                                        <h5 className="modal-title py-2 mb-1 text-left " id="exampleModalLabel">{activeMenu === "perso_info" ? "Informations Personnelles" : "Changement de mot de passe"}</h5>
                                    </div>
                                    <hr />
                                    <div className="w-90 mx-auto">

                                        {/* Postname and Sex */}

                                        {activeMenu === "perso_info" && <div className="d-flex flex-wrap">
                                            <div className="col-12">
                                                <div class="form-group row mb-4">
                                                    <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Nom</label>
                                                    <div class="col-sm-9">
                                                        <input type="text"
                                                            onChange={(e) => handleChangeEntry("nom", e)}
                                                            className={showErrorNom == true ? "form-control custom-form-control form-control-sm new-agent-error-input  mx-auto" : "custom-form-control form-control form-control-sm mx-auto"}
                                                            id="colFormLabelSm"
                                                            placeholder=""
                                                            value={agent.nom}
                                                            required />
                                                        {showErrorNom === true && <span className="new-agent-error-span">{nomErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div class="form-group row  mb-4">
                                                    <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Prénom</label>
                                                    <div class="col-sm-9">
                                                        <input type="text"
                                                            onChange={(e) => handleChangeEntry("prenom", e)}
                                                            className={showErrorPrenom == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                            id="colFormLabelSm"
                                                            placeholder=""
                                                            value={agent.prenom}
                                                            required />
                                                        {showErrorPrenom === true && <span className="new-agent-error-span">{prenomErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div class="form-group row  mb-4">
                                                    <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Téléphone</label>
                                                    <div class="col-sm-9">
                                                        <input type="text"
                                                            onChange={(e) => handleChangeEntry("telephone", e)}
                                                            className={showErrorTelephone == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                            id="colFormLabelSm"
                                                            placeholder=""
                                                            value={agent.telephone}
                                                            required />
                                                        {showErrorTelephone === true && <span className="new-agent-error-span">{telephoneErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div class="form-group row  mb-4">
                                                    <label for="libelle" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Email</label>
                                                    <div class="col-sm-9">
                                                        <input type="text"
                                                            onChange={(e) => handleChangeEntry("email", e)}
                                                            className={showErrorEmail == true ? "form-control form-control-sm new-agent-error-input custom-form-control  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"}
                                                            id="colFormLabelSm"
                                                            placeholder=""
                                                            value={agent.email}
                                                            required />
                                                        {showErrorEmail === true && <span className="new-agent-error-span">{emailErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div class="form-group row">
                                                    <label for="category" class="col-sm-3 col-form-label col-form-label-sm text-dark required">Sexe</label>
                                                    <div class="col-sm-9">
                                                        {/* <select id="zone-comparision"
                                                            onChange={(e) => selection(e, "sexe")}
                                                            className={"form-control custom-form-control basic"}
                                                        >
                                                            <option disabled selected hidden defaultValue={agent.sexe.value}>{agent.sexe?.label} </option>
                                                            {sexAgent !== [] && sexAgent?.map((item) => (
                                                                <option key={item.value} value={item.value}>{item.label}</option>
                                                            ))}
                                                        </select> */}
                                                         <Select
                                                        onChange={(e) => selection(e, "sexe")}
                                                        placeholder=""
                                                        className={showErrorSexe == true ? "new-institution-error-input " : ""}
                                                        classNamePrefix="select"
                                                        value={agent.sexe.label !== "" ? agent.sexe : ""}
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={true}
                                                        isRtl={false}
                                                        // isSearchable={true}
                                                        name="agent-sexe"
                                                        options={sexAgent}
                                                        styles={customStyles}
                                                    />

                                                        {showErrorSexe === true && <span className="new-product-error-span">{sexeErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}

                                        {activeMenu === "change_password" && <div className="d-flex flex-wrap">
                                            <div className="col-12">
                                                <div class="form-group row mb-4">
                                                    <label for="telephone" class="col-sm-6 col-xs-12 col-form-label col-form-label-sm text-dark required">Ancien Mot de passe</label>
                                                    <div class="col-sm-6 col-xs-12">
                                                        <div class="input-group mb-4"
                                                            className={showErrorOldPassword == true ? "input-group mb-4 new-institution-error-input" : "input-group mb-4"}
                                                        >
                                                            <input type={showOldPassword === true ? "text" : "password"}
                                                                placeholder=""
                                                                className={"form-control custom-form-control form-control-sm mx-auto pwd-input-focus"}
                                                                onChange={(e) => handleChangePassword("old", e)}
                                                                value={password.old}
                                                                style={{ borderRadius: "" }} />
                                                            <div class="input-group-append" >
                                                                <span class="input-group-text" id="basic-addon2">
                                                                    {showOldPassword === false && <AiFillEyeInvisible style={{ cursor: "pointer" }} onClick={handleDisplayOldPassword} />}
                                                                    {showOldPassword === true && <FiEye style={{ cursor: "pointer" }} onClick={handleDisplayOldPassword} />}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {/* <input type="password" disabled={operationType === "new" ? false : true} onChange={(e) => handleChangeEntry("password", e)} className={showErrorPassword == true ? "form-control form-control-sm new-institution-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.password} required /> */}
                                                        {showErrorOldPassword === true && <span className="new-institution-error-span">{oldPasswordErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div class="form-group row mb-4">
                                                    <label for="telephone" class="col-sm-6 col-xs-12 col-form-label col-form-label-sm text-dark required">Nouveau Mot de passe</label>
                                                    <div class="col-sm-6 col-xs-12">
                                                        <div class="input-group mb-4"
                                                            className={showErrorNewPassword == true ? "input-group mb-4 new-institution-error-input" : "input-group mb-4"}
                                                        >
                                                            <input type={showNewPassword === true ? "text" : "password"}
                                                                placeholder=""
                                                                className={"form-control custom-form-control form-control-sm mx-auto pwd-input-focus"}
                                                                onChange={(e) => handleChangePassword("new", e)}
                                                                value={password.new}
                                                                style={{ borderRadius: "" }} />
                                                            <div class="input-group-append" >
                                                                <span class="input-group-text" id="basic-addon2">
                                                                    {showNewPassword === false && <AiFillEyeInvisible style={{ cursor: "pointer" }} onClick={handleDisplayNewPassword} />}
                                                                    {showNewPassword === true && <FiEye style={{ cursor: "pointer" }} onClick={handleDisplayNewPassword} />}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {/* <input type="password" disabled={operationType === "new" ? false : true} onChange={(e) => handleChangeEntry("password", e)} className={showErrorPassword == true ? "form-control form-control-sm new-institution-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.password} required /> */}
                                                        {showErrorNewPassword === true && <span className="new-institution-error-span">{newPasswordErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div class="form-group row mb-1">
                                                    <label for="telephone" class="col-sm-6 col-xs-12 col-form-label col-form-label-sm text-dark required">Confirmation Mot de passe</label>
                                                    <div class="col-sm-6 col-xs-12">
                                                        <div class="input-group mb-4"
                                                            className={showErrorConfirmedPassword == true ? "input-group mb-4 new-institution-error-input" : "input-group mb-4"}
                                                        >
                                                            <input type={showConfirmedPassword === true ? "text" : "password"}
                                                                placeholder=""
                                                                className={"form-control custom-form-control form-control-sm mx-auto pwd-input-focus"}
                                                                onChange={(e) => handleChangePassword("confirmed", e)}
                                                                value={password.confirmed}
                                                                style={{ borderRadius: "" }} />
                                                            <div class="input-group-append" >
                                                                <span class="input-group-text" id="basic-addon2">
                                                                    {showConfirmedPassword === false && <AiFillEyeInvisible style={{ cursor: "pointer" }} onClick={handleDisplayConfirmedPassword} />}
                                                                    {showConfirmedPassword === true && <FiEye style={{ cursor: "pointer" }} onClick={handleDisplayConfirmedPassword} />}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {/* <input type="password" disabled={operationType === "new" ? false : true} onChange={(e) => handleChangeEntry("password", e)} className={showErrorPassword == true ? "form-control form-control-sm new-institution-error-input  mx-auto" : "form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={agent.password} required /> */}
                                                        {showErrorConfirmedPassword === true && <span className="new-institution-error-span">{confirmedPasswordErrorMessage}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        <hr className='marg-t-0 marg-b-0' />

                                        {activeMenu === "perso_info" && <Fragment> {processOngoingInfo == false ?
                                            <div className={"mb-3 col-xs-12 p-0 mx-auto mt-3"}>
                                                <button style={{ height: "35px", width: "150px" }} className="btn btn-dark"
                                                    onClick={() => handleUpdateUserPersoInfo()}
                                                >Modifier</button>
                                            </div> : <div className='mt-3'><ProcessSpinner /></div>}
                                        </Fragment>}

                                        {activeMenu === "change_password" && <Fragment> {processOngoingPassword == false ?
                                            <div className={"mb-3 col-xs-12 p-0 mx-auto mt-3"}>
                                                <button style={{ height: "35px", width: "150px" }} className="btn btn-dark"
                                                    onClick={() => handleUpdateUserPassword()}
                                                >Modifier</button>
                                            </div> : <div className='mt-3'><ProcessSpinner /></div>}
                                        </Fragment>}



                                    </div>
                                    <div className="row my-3"></div>
                                </div>

                            </div>



                        </div> : <div style={{ marginTop: "25%" }}>
                            <Loader />
                        </div>}

                </div>
            </div>
        </div>



    )
}

export default UserDetails